<div class="register-form relative-left txt-center">
  <!-- register form -->
  <div class="ldgm-header ldgm-header-{{lottoId}}-{{sys}} relative-left full-width v-center">
    <h3 class="dcell">{{'ACCOUNT' | translate}}</h3>
    <a class="top-nav fixed inline-block" role="button" aria-hidden="true"></a>
  </div>
  <div class="relative-left ldgm-body full-width">
    <form [formGroup]="registerForm" class="ldgm-form relative">
      <div class="ldgm-input-wrap">
        <label class="fleft" id="{{sys}}-label"> {{'form.fname' | translate}} </label>
        <div class="relative-left f-control">
          <input type="text" formControlName="name" />
          <div class="field_error full-width" *ngIf="onValidator('name', 'required')">{{'LOGIN.VALIDATE.NAME.REQUIRED' | translate}}</div>
          <div class="field_error full-width" *ngIf="onValidator('name', 'pattern')">{{'LOGIN.VALIDATE.NAME.ENTER' | translate}}</div>
          <div class="field_error full-width" *ngIf="onValidator('name', 'maxlength')">{{'LOGIN.VALIDATE.NAME.MAXIMUN' | translate}}</div>
        </div>
      </div>
      <div class="ldgm-input-wrap">
        <label class="fleft" id="{{sys}}-label"> {{'form.lname' | translate}} </label>
        <div class="relative-left f-control">
          <input type="text" formControlName="last_name" />
          <div class="field_error full-width" *ngIf="onValidator('last_name', 'required')">{{'LOGIN.VALIDATE.NAME.REQUIRED' | translate}}</div>
          <div class="field_error full-width" *ngIf="onValidator('last_name', 'minlength') || onValidator('last_name', 'pattern')">
            {{'LOGIN.VALIDATE.NAME.ENTER' | translate}}
          </div>
          <div class="field_error full-width" *ngIf="onValidator('last_name', 'maxlength')">{{'LOGIN.VALIDATE.NAME.MAXIMUN' | translate}}</div>
        </div>
      </div>

      <div class="ldgm-body full-width">
        <div class="ldgm-input-wrap">
          <label class="fleft" id="{{sys}}-label"> {{'form.email' | translate}} </label>

          <div class="relative-left i-icon f-control">
            <i class="icon email absolute" aria-hidden="true"></i>
            <input
              oninput="this.value = this.value.toLowerCase()"
              formControlName="email"
              type="email"
              (ngModelChange)="this.errorMailExist = false"
            />
            <div class="field_error full-width" style="display: block" *ngIf="onValidator('email', 'required')">
              {{'LOGIN.VALIDATE.MAIL.ENTER' | translate}}
            </div>
            <div class="field_error full-width" style="display: block" *ngIf="onValidator('email', 'pattern')">
              {{'LOGIN.VALIDATE.MAIL.REQUIRED' | translate}}
            </div>
          </div>
        </div>

        <div class="ldgm-input-wrap">
          <label class="fleft" id="{{sys}}-label"> {{'form.pass' | translate}} </label>
          <div class="relative-left i-icon f-control">
            <i class="icon padlock absolute" aria-hidden="true"></i>
            <input type="password" class="i-pass" formControlName="password" [type]="isHide ? 'password' : 'text'" />
            <a class="toggle-pass absolute inline-block" data-show="Hide password" data-hide="Show password" (click)="showPassword()"
              >Mostrar contraseña</a
            >
            <div class="field_error full-width" *ngIf="onValidator('password', 'required')">{{'LOGIN.VALIDATE.PASSWORD.ENTER' | translate}}</div>
            <div class="field_error full-width" *ngIf="registerForm.get('password').errors?.minlength">
              {{'LOGIN.VALIDATE.PASSWORD.MINIMUN' | translate}}
            </div>
            <div class="field_error full-width" *ngIf="onValidator('password', 'pattern')">{{'LOGIN.VALIDATE.PASSWORD.SPECIALCHAR' | translate}}</div>
            <div class="field_error full-width" *ngIf="onValidator('password', 'maxlength')">{{'LOGIN.VALIDATE.PASSWORD.MAXIMUN' | translate}}</div>
          </div>
        </div>

        <div class="ldgm-input-wrap">
          <label class="fleft" id="{{sys}}-label"> {{'LOGIN.PLACEHOLDER.COUNTRY_BIRTH' | translate}} </label>
          <div class="relative-left f-control">
            <div class="custom-select">
              <input
                type="text"
                placeholder="Ex. Canadá"
                aria-label="Your Birth Country"
                matInput
                formControlName="country_birth"
                [matAutocomplete]="countryBornAutoComplete"
                (ngModelChange)="getBirthCountry();"
              />
              <mat-icon matPrefix>landscape</mat-icon>
              <mat-autocomplete #countryBornAutoComplete="matAutocomplete">
                <mat-option *ngFor="let option of filteredBirthCountries | async" [value]="option.name" (onSelectionChange)="getBirthCountry(option)">
                  {{option.name}}
                </mat-option>
              </mat-autocomplete>
            </div>
            <div class="field_error full-width" *ngIf="onValidator('country_birth', 'required') || onValidator('country_birth', 'pattern')">
              {{'LOGIN.VALIDATE.COUNTRY.ENTER' | translate}}
            </div>
            <div class="field_error full-width" *ngIf="registerForm.get('country_birth').errors && registerForm.get('country_birth').touched">
              <p *ngIf="registerForm.get('country_birth').hasError('MatchBirthCountry')">{{'LOGIN.VALIDATE.COUNTRY.ENTER' | translate}}</p>
            </div>
          </div>
        </div>

        <div class="ldgm-input-wrap">
          <label class="fleft" id="{{sys}}-label"> {{'form.birthday' | translate}} </label>
          <div class="relative-left f-control">
            <input type="date" formControlName="birthdate" />
            <div class="field_error full-width">
              <div class="field_error full-width" *ngIf="onValidator('birthdate', 'required')">{{'LOGIN.VALIDATE.AGE.ENTER' | translate}}</div>
              <div class="field_error full-width" *ngIf="onValidator('birthdate', 'NotAdult')">{{'LOGIN.VALIDATE.AGE.MINIMUN' | translate}}</div>
              <div class="field_error full-width" *ngIf="onValidator('birthdate', 'TooOld')">{{'LOGIN.VALIDATE.AGE.MAXIMUN' | translate}}</div>
            </div>
          </div>
        </div>
        <div class="ldgm-input-wrap">
          <label class="fleft" id="{{sys}}-label"> {{'LOGIN.PLACEHOLDER.COUNTRY' | translate}} </label>
          <div class="relative-left f-control">
            <div class="custom-select">
              <input
                type="text"
                placeholder="Ex. Canadá"
                aria-label="Your Country"
                matInput
                formControlName="country"
                [matAutocomplete]="auto"
                (ngModelChange)="setDialCode();countryControls();getCountry()"
              />
              <mat-icon matPrefix>landscape</mat-icon>
              <mat-autocomplete #auto="matAutocomplete">
                <mat-option *ngFor="let option of filteredCountries | async" [value]="option.name" (onSelectionChange)="getCountry(option)">
                  {{option.name}}
                </mat-option>
              </mat-autocomplete>
            </div>
            <div class="field_error full-width" *ngIf="onValidator('country', 'required') || onValidator('country', 'pattern')">
              {{'LOGIN.VALIDATE.COUNTRY.ENTER' | translate}}
            </div>
            <div class="field_error full-width" *ngIf="registerForm.get('country').errors && registerForm.get('country').touched">
              <p *ngIf="registerForm.get('country').hasError('MatchCountry')">{{'LOGIN.VALIDATE.COUNTRY.ENTER' | translate}}</p>
            </div>
          </div>
        </div>

        <div class="ldgm-input-wrap" *ngIf="showState">
          <label class="fleft" id="{{sys}}-label"> {{'LOGIN.PLACEHOLDER.STATE' | translate}} </label>
          <div class="relative-left f-control">
            <div class="custom-select">
              <input
                type="text"
                aria-label="Your State"
                matInput
                formControlName="state"
                [matAutocomplete]="auto"
                placeholder="{{'form.stateExample' | translate }}"
              />
              <mat-icon matPrefix>landscape</mat-icon>
              <mat-autocomplete #auto="matAutocomplete">
                <mat-option *ngFor="let states of filteredStates | async" [value]="states.name"> {{states.name}} </mat-option>
              </mat-autocomplete>
            </div>
            <div class="field_error full-width" *ngIf="onValidator('state', 'required') || onValidator('state', 'pattern')">
              {{'LOGIN.VALIDATE.STATE.ENTER' | translate}}
            </div>
          </div>
        </div>

        <div id="div_cpf" class="ldgm-input-wrap" *ngIf="country?.iso ==='BR'">
          <label class="fleft" id="{{sys}}-label">
            <small>{{'CPF.TITLE' | translate}}</small>
          </label>
          <div class="relative-left f-control">
            <input type="text" id="Ssn" name="Ssn" formControlName="ssn" class="fleft" />
            <div class="field_error full-width">
              <div *ngIf="errorCpfInvalid" class="field_error full-width">
                <div class="field_error full-width">{{'LOGIN.VALIDATE.CPF.ENTER' | translate}}</div>
              </div>
            </div>
            <div *ngIf="!errorCpfInvalid" id="div_cpf_text" class="under-field">
              <p class="undernote" style="float: right; text-align: left; font-size: 14px">
                <small>{{'CPF.CONTENT' | translate}}</small>
              </p>
            </div>
          </div>
        </div>

        <div id="div_cpf" class="ldgm-input-wrap" *ngIf="country?.iso !=='BR'">
          <label class="fleft" id="{{sys}}-label">
            <small>{{'form.ssn' | translate}}</small>
          </label>
          <div class="relative-left f-control">
            <input type="text" id="Ssn" name="Ssn" formControlName="ssn" class="fleft" />
            <div class="field_error full-width">
              <div *ngIf="errorCpfInvalid" class="field_error full-width">
                <div class="field_error full-width">{{'LOGIN.VALIDATE.CPF.ENTER' | translate}}</div>
              </div>
            </div>
          </div>
        </div>

        <div class="ldgm-input-wrap" *ngIf="country?.iso ==='CO'">
          <label class="fleft" id="{{sys}}-label"> {{'form.ssn_type' | translate}} </label>
          <div class="relative-left f-control">
            <div class="custom-select">
              <input
                type="text"
                aria-label="Your SSN Type"
                matInput
                formControlName="ssn_type"
                [matAutocomplete]="autoSSNType"
                (ngModelChange)="getSSNOption();"
              />
              <mat-icon matPrefix>perm_identity</mat-icon>
              <mat-autocomplete #autoSSNType="matAutocomplete">
                <mat-option *ngFor="let type of filteredOptions | async" [value]="type.name" (onSelectionChange)="getSSNOption(type)">
                  {{type.name}}
                </mat-option>
              </mat-autocomplete>
            </div>
            <div class="field_error full-width" *ngIf="onValidator('ssn_type', 'required')">{{'LOGIN.VALIDATE.SSN_TYPE.ENTER' | translate}}</div>
            <div class="field_error full-width" *ngIf="registerForm.get('ssn_type').errors && registerForm.get('ssn_type').touched">
              <p *ngIf="registerForm.get('ssn_type').hasError('MatchSSNType')">{{'LOGIN.VALIDATE.SSN_TYPE.ENTER' | translate}}</p>
            </div>
          </div>
        </div>

        <div class="ldgm-input-wrap">
          <label class="fleft" id="{{sys}}-label"> {{'form.phone' | translate}} </label>
          <div class="relative-left f-control">
            <input type="phone" formControlName="phone" />
            <div class="field_error full-width" *ngIf="onValidator('phone', 'pattern')">{{'LOGIN.VALIDATE.PHONE.ONLY' | translate}}</div>
            <div class="field_error full-width" *ngIf="onValidator('phone', 'maxlength') || errorNumberPhone">
              {{'LOGIN.VALIDATE.PHONE.ENTER' | translate}}
            </div>
          </div>
        </div>

        <div class="ldgm-input-wrap">
          <label class="fleft" id="{{sys}}-label"> {{'form.direccion' | translate}} </label>
          <div class="relative-left f-control">
            <input type="phone" formControlName="address1" />
            <div class="field_error full-width" *ngIf="onValidator('address1', 'required')">{{'form.error' | translate}}</div>
          </div>
        </div>

        <div class="ldgm-input-wrap">
          <label class="fleft" id="{{sys}}-label"> {{'form.city' | translate}} </label>
          <div class="relative-left f-control">
            <input type="text" formControlName="city" />
            <div class="field_error full-width" *ngIf="onValidator('city', 'required')">{{'form.error' | translate}}</div>
          </div>
        </div>

        <div class="ldgm-input-wrap">
          <label class="fleft" id="{{sys}}-label"> {{'form.zipcode' | translate}} </label>
          <div class="relative-left f-control">
            <input type="text" formControlName="zipcode" />
            <div class="field_error full-width" *ngIf="onValidator('zipcode', 'required')">{{'form.error' | translate}}</div>
          </div>
        </div>

        <div class="ldgm-input-wrap lgm-input-submit-wrap full-width txt-left">
          <input
            id="button-{{ sys }}"
            class="ldgm-submit button-{{ sys }}"
            *ngIf="!loading"
            type="submit"
            [value]="'PlayNow' | translate"
            (click)="changeStep($event)"
          />
        </div>
        <div class="terms-container full-width">
          <mat-checkbox [checked]="acceptTerms ? true : false" (change)="onCheckboxChange($event)" class="terms"> </mat-checkbox>
          <p style="font-size: 12px !important; line-height: 35px; margin-left: -10px" *ngIf="('lang' | translate) === 'es'">
            <span style="text-transform: Capitalize; line-height: 35px">Confirmo </span>que acepto los
            <span class="link" (click)="redirecToTerms()">términos y condiciones</span>
          </p>
          <p style="font-size: 12px !important; line-height: 35px; margin-left: -10px" *ngIf="('lang' | translate) === 'en'">
            <span style="text-transform: Capitalize; line-height: 35px">I confirm </span>I accept them
            <span class="link" (click)="redirecToTerms()">terms and Conditions</span>
          </p>
          <p style="font-size: 12px !important; line-height: 35px; margin-left: -10px" *ngIf="('lang' | translate) === 'pt'">
            <span style="text-transform: Capitalize; line-height: 35px">Confirmar </span>que aceito los
            <span class="link" (click)="redirecToTerms()">términos y condiciones</span>
          </p>
        </div>

        <h4 *ngIf="errorFormInvalid" class="login-error-msg full-width txt-center padding-5">{{'ERROR.GENERIC' | translate}}</h4>
        <h4 *ngIf="errorMailExist" class="login-error-msg full-width txt-center padding-5">{{'LOGIN.VALIDATE.MAIL.EXISTS' | translate}}</h4>
        <h4 *ngIf="errorCpfInvalid" class="login-error-msg full-width txt-center padding-5">{{'CPF.CONTENT' | translate}}</h4>
        <h4 *ngIf="errorNumberPhone" class="login-error-msg full-width txt-center padding-5">{{'LOGIN.VALIDATE.PHONE.ENTER' | translate}}</h4>
        <h4 *ngIf="errorInvalidState" class="login-error-msg full-width txt-center padding-5">{{'LOGIN.VALIDATE.STATE.ENTER' | translate}}</h4>

        <div *ngIf="loading">
          <app-spinner></app-spinner>
        </div>
        <h4 *ngIf="error && !loading" class="login-error-msg full-width txt-center padding-5">{{'ERROR.GENERIC' | translate}}</h4>
      </div>
    </form>
  </div>
</div>
